import { Check } from 'lucide-react';
import clsx from 'clsx';

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
  labelClassName?: string;
};

export const Checkbox = ({ value, onChange, label, labelClassName }: Props) => {
  return (
    <div className="flex items-center gap-[5px] justify-center cursor-pointer">
      <div
        onClick={() => onChange(!value)}
        className={clsx(
          'w-[14px] h-[14px] p-[1px] border border-gray-600 flex items-center justify-center rounded-sm',
          value ? 'bg-blue-500' : 'bg-dark'
        )}
      >
        {value && <Check size={14} color="white" />}
      </div>
      {label && <div className={clsx('text-[14px]', labelClassName)}>{label}</div>}
    </div>
  );
};
